
import { normalizeAngle, Angle, angleBetween } from './angle'
import { lt, gt } from './util'
import { Point } from './point'
import { vector } from './vector'

export type Quad = [number, number, number, number]
export const QUADRANT_ANGLES = [0, Angle.PI_2, Angle.PI, 3*Angle.PI_2]

// returns the quandrant as an index
// rounds the angle to the quadrant in its range
function toQuadrantIndex(theta: number): number {

  const angle = normalizeAngle(theta)

  if (gt(angle, 3*Angle.PI_4) && lt(angle, 5*Angle.PI_4)) {
    return 2
  }

  if (angleBetween(angle, Angle.PI_4, 3*Angle.PI_4)) {
    return 1
  }

  if (angle > 5*Angle.PI_4 && angle < 7*Angle.PI_4) {
    return 3
  }

  // if (angleBetween(angle, 7*Angle.PI_4, Angle.PI_4)) {
  //   return 0
  // }

  return 0
}

// returns the quandrant of the source as seen from the target as an index
export function toQuadrant(source: Point, sourceHeading: number, target: Point): number {
  const v0 = vector(source, target)
  const angle0 = v0.angle()

  return toQuadrantIndex(angle0-sourceHeading)
}
